import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const searchTxParams = 'sale|lease|both|sale-and-both|lease-and-both|sale-and-lease|sale-and-lease-and-both';
  const searchIcsParams = 'industrial|office|shops';

  const router = new Router({
    mode: 'history',
    base: '/ics/property/find/',
    routes: [
      {
        name: 'search',
        path: `/:p1(${searchIcsParams}|${searchTxParams})?/:p2(${searchTxParams})?`,
        component: () => import('./search'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  router.beforeEach((to, from, next) => {
    Vue.$gmapDefaultResizeBus.$emit('resize');
    next();
  });

  return router;
};
